// @flow
import React, { PureComponent } from 'react';
import type { BlocContent } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import Sidebar from 'components/sidebar/Sidebar';

export type StateProps = {
  documents: BlocContent[],
};

export type Props = StateProps;

class CompetitionDocuments extends PureComponent<Props> {
  renderContent = () => {
    const { documents } = this.props;

    if (!documents) {
      return null;
    }
    return documents.map<any>((blocFigure, index) => <ContentBloc key={index} {...blocFigure} />);
  }

  render() {
    return(
      <div className="container">
        <div className="row">
          <div className="col col-md-8 col-lg-9 bg-overflow">
            <section>
              <div className="row">
                <div className="col col-lg-8on9 page">
                  {this.renderContent()}
                </div>
              </div>
            </section>
          </div>
          <Sidebar />
        </div>
      </div>
    );
  }
}

export default CompetitionDocuments;
